module.exports = __webpack_public_path__ + "img/SAP_8968p.13a21e08.jpg";